import { UnstyledButton, Group, Text, createStyles, Modal } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconChevronRight } from "@tabler/icons";
import { useState } from "react";
import Profile from "../pages/Users/Profile";
import { PersonAvatar } from "./PersonAvatar";

const useStyles = createStyles((theme) => ({
  user: {
    display: "block",
    width: "100%",
    padding: theme.spacing.md,
    color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,

    "&:hover": {
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0],
    },
  },
}));

export function UserButton({
  didNavigate,
  name,
  icon,
  currentUser,
  userClaims,
  userToken,
  companyId,
  companyData,
  isHarvestForecastEnabled,
  ...others
}) {
  const { classes } = useStyles();

  const [isUserOpen, setUserOpen] = useState(false);

  // A fixed size="50%" is fine on desktop but becomes a cramped sliver on a phone (50% of a
  // 375px screen is well under 200px) - fullScreen on small viewports gives Profile's tabs and
  // form fields the entire screen to work with instead, the same "modal becomes fullscreen on
  // mobile" pattern Mantine itself recommends.
  const isMobileViewport = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <Modal
        opened={isUserOpen}
        onClose={() => setUserOpen(false)}
        title="Your Profile"
        centered={!isMobileViewport}
        fullScreen={isMobileViewport}
        size={isMobileViewport ? "auto" : "50%"}
      >
        <Profile
          currentUser={currentUser}
          userClaims={userClaims}
          userToken={userToken}
          companyId={companyId}
          companyData={companyData}
          isHarvestForecastEnabled={isHarvestForecastEnabled}
        />
      </Modal>
      <UnstyledButton className={classes.user} {...others} onClick={() => setUserOpen(true)}>
        <Group>
          <PersonAvatar name={name} />
          <div style={{ flex: 1, maxWidth: 145 }}>
            <Text size="sm" weight={500} lineClamp={1}>
              {name}
            </Text>
            <Text color="dimmed" size="xs" lineClamp={1}>
              View Profile
            </Text>
          </div>
          {icon || <IconChevronRight color="gray" size="1.25rem" stroke={2} />}
        </Group>
      </UnstyledButton>
    </>
  );
}
